import { PencilSimple } from "@phosphor-icons/react";
import { phaseRegistry } from "../registry.js";
import { PhaseTile } from "../components.js";
import { ItemTable } from "../table.js";
import {
  EmptyState,
  EmptyStateIcon,
  EmptyStateTitle,
} from "@/components/ui/empty-state";

const EditingPage = () => {
  return (
    <ItemTable
      search="phase:editing"
      emptyState={
        <EmptyState>
          <EmptyStateIcon>
            <PencilSimple />
          </EmptyStateIcon>
          <EmptyStateTitle>No items to edit.</EmptyStateTitle>
        </EmptyState>
      }
    />
  );
};

const EditingTile = () => {
  return (
    <PhaseTile phase="editing">
      <PencilSimple size={24} />
    </PhaseTile>
  );
};

phaseRegistry.register({
  type: "editing",
  order: 2,
  page: EditingPage,
  tile: EditingTile,
});
